<app-centre-small-opener>
    <h2 dialogTitle class="mar-b-5 pd-t-5px">{{data.title}}</h2>
    <div contentContainer class="row">
        <div class="col-lg-12 col-sm-12" style="padding: 0px;">
            <form class="col-lg-12 d-lg-flex col-sm-12 d-sm-flex">
                <div class="col-12" style="padding: 0px;">

                    <div class="align-items-center" style="display: inline-block;">
                        <input type="radio" (change)="showAddParticipants()" checked id="participants"
                            style="margin-right: 10px;" name="group-1" />
                        <label for="participants">Send to selected participants</label>
                    </div> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;

                    <div class="align-items-center" style="display: inline-block;">
                        <input type="radio" id="all-participants" name="group-1" style="margin-right: 10px;"
                            (change)="hideAddParticipants()" />
                        <label for="all-participants">Send to all participants</label>
                    </div>



                    <mat-form-field *ngIf="particToggler" style="width: 100%;">
                        <mat-label>Select the participants</mat-label>
                        <mat-select disableOptionCentering panelClass="common-drop-down-class" id-=""
                            [formControl]="toppingsControl" multiple (blur)="callTrigger()">

                            <mat-select-trigger>
                                <mat-chip-listbox>
                                    <mat-chip-option *ngFor="let topping of toppingsControl.value" [removable]="true"
                                        (removed)="onToppingRemoved(topping,0)">
                                        {{ topping.attendeeName }}
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip-option>
                                </mat-chip-listbox>
                            </mat-select-trigger>

                            <mat-option *ngFor="let topping of data.meetingResp.attendeeList"
                                [value]="topping">{{topping.attendeeName}}</mat-option>
                        </mat-select>
                    </mat-form-field>


                    <div style="margin-top: 2px;">
                        <mat-label style="margin-bottom: 5px;">Additionally send to </mat-label>
                        <mat-form-field style="width: 100%;">
                            <mat-chip-listbox>
                                <mat-chip-option *ngFor="let topping of newPresenterList" [removable]="true"
                                    (removed)="onToppingRemoved(topping,1)">
                                    {{topping.attendeeName}}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip-option>
                            </mat-chip-listbox>

                            <input matInput id="messageUser" (click)="loadPresenter($event.target, 'messageUser')" />
                        </mat-form-field>
                    </div>

                    <mat-form-field style="width: 100%;">
                        <mat-label>Subject</mat-label>
                        <input matInput #messageSubject [(ngModel)]="subject" name="something" type="text" />
                    </mat-form-field>

                    <div class="d-flex align-items-center">
                        <div style="width: 100%;">
                            <mat-label>Body Content</mat-label>
                            <ckeditor #agSendckeditor class="body-font-size" [data]="data" [config]="ckEditorConfig">
                            </ckeditor>
                        </div>
                    </div>

                </div>
            </form>
        </div>
    </div>

    <div class="d-flex justify-content-end" actions>
        <button mat-raised-button actions contentType="template" color="primary" class="button-container mar-l-8"
            (click)="reset()">
            RESET
        </button>
        <button mat-raised-button actions contentType="template" color="primary" class="button-container mar-l-8"
            (click)="sendDraft()">
            SUBMIT
        </button>
        <button mat-raised-button mat-dialog-close type="reset" color="primary" actions
            class="button-container mar-l-8">
            CANCEL
        </button>
    </div>
</app-centre-small-opener>
